import React from "react";
export interface PageAreaProviderProps {
    value: PageArea | undefined;
    children: React.ReactNode;
}
export function PageAreaProvider({ value, children }: PageAreaProviderProps) {
    return <PageAreaContext.Provider value={value}>{children}</PageAreaContext.Provider>;
}
export function usePageArea() {
    return React.useContext(PageAreaContext);
}
type PageAreas = typeof pageAreas;
export type PageArea = PageAreas[Exclude<keyof PageAreas, "deploy">] | PageAreas["deploy"][keyof PageAreas["deploy"]];
export const pageAreas = {
    deploy: {
        projects: { mainArea: "Deploy", subArea: "Projects" },
        tenants: { mainArea: "Deploy", subArea: "Tenants" },
        infrastructure: { mainArea: "Deploy", subArea: "Infrastructure" },
        manage: { mainArea: "Deploy", subArea: "Manage" },
    },
    insights: { mainArea: "Insights" },
    tasks: { mainArea: "Tasks" },
    approvals: { mainArea: "Approvals" },
    configuration: { mainArea: "Configuration" },
    userProfile: { mainArea: "User Profile" },
    devTools: { mainArea: "Dev Tools" },
    platformHub: { mainArea: "Platform Hub" },
} as const;
const PageAreaContext = React.createContext<PageArea | undefined>(undefined);
